import {Button, Card, styled, Typography} from '@mui/material';

const StyledCard = styled(Card)`
	box-shadow: none;
`;

const StyledTitle = styled(Typography)`
	padding: 12px 16px;
	font-size: 18px;
`;

const StyledDescription = styled(Typography)`
	padding: 8px 16px;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	height: 60px;
`;

const StyledButton = styled(Button)`
	text-decoration: underline;
	:hover {
		text-decoration: underline;
		background-color: transparent;
	}
`;

export {StyledButton, StyledCard, StyledDescription, StyledTitle};
